import { useEffect } from "react";
import "@/App.css";
import "@/light-theme.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SEO from "@/components/SEO";
import axios from "axios";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import ClientLogos from "@/components/ClientLogos";
import ServicesShowcase from "@/components/ServicesShowcase";
import FeaturedWork from "@/components/FeaturedWork";
import ProcessSection from "@/components/ProcessSection";
import Testimonials from "@/components/Testimonials";
import CTASection from "@/components/CTASection";
import Footer from "@/components/Footer";
import About from "@/pages/About";
import CaseStudies from "@/pages/CaseStudies";
import CaseStudyDetail from "@/pages/CaseStudyDetail";
import Services from "@/pages/Services";
import RealEstate from "@/pages/industries/RealEstate";
import Fintech from "@/pages/industries/Fintech";
import WealthManagement from "@/pages/industries/WealthManagement";
import InvestmentBanking from "@/pages/industries/InvestmentBanking";
import ProductDevelopment from "@/pages/services/ProductDevelopment";
import AISolutions from "@/pages/services/AISolutions";
import StaffAugmentation from "@/pages/services/StaffAugmentation";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Home = () => {
  const helloWorldApi = async () => {
    try {
      const response = await axios.get(`${API}/`);
      console.log(response.data.message);
    } catch (e) {
      console.error(e, `errored out requesting / api`);
    }
  };

  useEffect(() => {
    helloWorldApi();
    
    // Remove Emergent badge if it exists
    const removeBadge = () => {
      const badge = document.getElementById('emergent-badge');
      if (badge) {
        badge.remove();
      }
      
      // Also remove any links with emergent.sh
      const emergentLinks = document.querySelectorAll('a[href*="emergent.sh"]');
      emergentLinks.forEach(link => link.remove());
    };
    
    // Remove immediately
    removeBadge();
    
    // Also check after a delay in case it's added dynamically
    const timeoutId = setTimeout(removeBadge, 1000);
    
    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <SEO
        description="We build AI-powered products, full-stack platforms, and engineering teams for enterprises and funded startups. 150+ team members, 500+ completed projects, 15+ years in the business."
        path="/"
      />
      <Header />
      <HeroSection />
      <ClientLogos />
      <ServicesShowcase />
      <FeaturedWork />
      <ProcessSection />
      <Testimonials />
      <CTASection />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/case-studies" element={<CaseStudies />} />
          <Route path="/case-studies/:slug" element={<CaseStudyDetail />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/product-development" element={<ProductDevelopment />} />
          <Route path="/services/ai-solutions" element={<AISolutions />} />
          <Route path="/services/staff-augmentation" element={<StaffAugmentation />} />
          <Route path="/industries/real-estate" element={<RealEstate />} />
          <Route path="/industries/fintech" element={<Fintech />} />
          <Route path="/industries/wealth-management" element={<WealthManagement />} />
          <Route path="/industries/investment-banking" element={<InvestmentBanking />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
